
/*
    🔥 PUNTO DE ENTRADA DE LA CARPETA

    Lo que consume el resto de la app sale de acá y de ningún otro archivo de _Company:

        import { APP_COMPANY, GET_COMPANY_LOGO } from "./_Company";

    ⚠️ APPLY_COMPANY_IDENTITY NO SE RE-EXPORTA ACÁ A PROPÓSITO.
       _MetaTagsIcons.js importa este archivo, así que re-exportarlo desde acá armaría
       una dependencia circular. Se importa directo desde _MetaTagsIcons.js en index.js.
*/

import { COMPANY_META_TAGS } from "./_MetaTags";
import { APP_COMPANY_CONFIG } from "./AppCompanyConfig";
import { OBJECT_FREEZE_HELPER } from "../../HELPERS/objectFreeze.helper";


export const _SCHEMA = {

    ...APP_COMPANY_CONFIG,
    ...COMPANY_META_TAGS,

};

export const APP_COMPANY = OBJECT_FREEZE_HELPER.DEEP_FREEZE(_SCHEMA);


// El logo se arma en _GetLogo.js; se re-exporta para no tener que conocer ese archivo desde afuera.
export { GET_COMPANY_LOGO, GET_ACTIVE_LOGO, APP_LOGO_CALENDAR } from "./_GetLogo";